export enum DuluxSpecificBehaviourWorkspaceCapabilityAccessOperation {
    create = "fb2fb438-0a07-4940-8442-765212d1ab2d",
    read = "39ec2692-6f4d-4908-8583-89a507715bb4",
    update = "b62af2cc-8429-4cdf-8e80-9446bd2e51d7",
    delete = "c05c9f11-db3d-4178-a874-6411bf5d9561",
}
